import React from 'react';
import Icon from '@mdi/react';
import { mdiAccountSchool } from '@mdi/js';
import theme from '../theme'; 

export const StudentIcon = (color, size) => (
  <Icon 
    size={size}
    path={mdiAccountSchool}
    title="School"
    color={theme.white}
  />
);